// @ts-nocheck
export const siteBannersHeightVariable = "--site-banners-height";

/** Full viewport height minus the site banners shown at the top of the page. */
export const fullViewportHeight = `calc(100vh - var(${siteBannersHeightVariable}))`;
